// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"bulkActions__B1qrV","text":"text__H-Rzs","inputs":"inputs__2VV1O","input":"input__hAZdD","buttons":"buttons__nHNt3"};